import service from 'domain/services/service';

export async function searchRecording(meeting, setIsLoading) {
  setIsLoading(true);
  return service.post(`/recordings/${meeting}`).catch((e) => {
    const error = (e && e.message) || e.statusText;
    return Promise.reject(error);
  });
}
